import React from "react";
import { createPortal } from "react-dom";
import { AssetItemProps } from "../asset-item";
import { BarDisplay } from "./bar-display";
import { BarPoint } from "./bar-point";
import styles from "./bar.module.css";

export const Bar: React.FC<AssetItemProps> = ({
	asset,
	onEventStart,
	isSelected,
	processLinesRef,
	isHighlighted,
}) => {
	const isTaskLine = asset.type === "taskLine";
	const isNotDelay = isTaskLine && asset.source.eventCode !== "D";
	// TaskLines get smaller border radius (3), main tasks use the configured value
	const borderRadius = isNotDelay ? 0 : isTaskLine ? 3 : asset.barCornerRadius;
	const subEventsHeight = isNotDelay ? 9 : asset.height;
	const subEventY = isNotDelay ? asset.y + asset.height - 11 : asset.y;

	// Check if this is a point-in-time event (like charges)
	const isPointInTime = asset.isPointInTime === true;

	return (
		<g className={styles.barWrapper} tabIndex={0}>
			{createPortal(
				<>
					{asset.drawLine ? (
						<line
							x1={0}
							y1={asset.y + asset.height / 2}
							x2="100%"
							y2={asset.y + asset.height / 2}
							stroke="black"
							strokeOpacity={"1"}
							strokeWidth="0.4"
							pointerEvents="none"
						/>
					) : null}
				</>,
				processLinesRef.current || document.body,
			)}
			{isPointInTime ? (
				<BarPoint
					id={`${asset.name}-${asset.id}`}
					x={asset.x1}
					y={subEventY}
					height={subEventsHeight}
					styles={asset.styles}
					isSelected={isSelected}
				/>
			) : (
				<BarDisplay
					id={`${asset.name}-${asset.id}`}
					x={asset.x1}
					y={subEventY}
					width={asset.x2 - asset.x1}
					height={subEventsHeight}
					progressX={asset.progressX}
					progressWidth={asset.progressWidth}
					barCornerRadius={borderRadius}
					styles={asset.styles}
					isSelected={isSelected}
					isHighlighted={isHighlighted}
					useGradient={asset.type === "task"}
				/>
			)}

			<g className="handleGroup"></g>
		</g>
	);
};
